import { useTranslation } from "react-i18next";
import {usePagination, useTable} from "react-table";
import styles from "../ManagePollsPage/ManagePolls.module.css";
import {Table} from "react-bootstrap";
import NormalPagination from "../../components/pagination/NormalPagination";
import React from "react";
import Skeleton from "react-loading-skeleton";
import classes from "./ReleaseActivityPage.module.css";
import ProfileIcon from "../../components/ProfileIcon";
import {ReactComponent as NO_RESULT_FOUND} from "../../images/no-result-found.svg"
import {POLL_TYPE} from "../../utils/constants";

export default function ViewMetricParticipantsTable({data, columns, dataLoading, pollType}) {
    const { t } = useTranslation();
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        page,
        canPreviousPage,
        canNextPage,
        pageOptions,
        pageCount,
        gotoPage,
        nextPage,
        previousPage,
        state: { pageIndex, pageSize},
    } = useTable({
        columns,
        data,
        initialState: { pageIndex: 0, pageSize: 10 },
        autoResetPage: true,
    }, usePagination);


    if (dataLoading) {
        const skeletonLoaderStyle = {width: "100%", flex: 1, minHeight: 0, maxHeight: 30};
        return (
            <>
                <div className={styles.tableContainer} style={{marginTop: 25, minHeight: 0}}>
                    <div className={styles.tableWrapper} >
                        <Table {...getTableProps()}>
                            <thead>
                            <tr>
                                <th>
                                     <span style={{...skeletonLoaderStyle, width: 120}}>
                                        <Skeleton highlightColor="lightgrey" width="100%" height="100%" borderRadius={4}/>
                                    </span>
                                </th>
                            </tr>
                            </thead>
                            <tbody {...getTableBodyProps()}>
                            <tr>
                                <td>
                                        <span style={{...skeletonLoaderStyle, width: 300}}>
                                            <Skeleton highlightColor="lightgrey" width="100%" height="100%"
                                                      borderRadius={4}/>
                                        </span>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                        <span style={{...skeletonLoaderStyle, width: 200}}>
                                            <Skeleton highlightColor="lightgrey" width="100%" height="100%"
                                                      borderRadius={4}/>
                                        </span>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                        <span style={{...skeletonLoaderStyle, width: 150}}>
                                            <Skeleton highlightColor="lightgrey" width="100%" height="100%"
                                                      borderRadius={4}/>
                                        </span>
                                </td>
                            </tr>
                            </tbody>
                        </Table>
                    </div>
                </div>
            </>
        );
    }


    return (
        <>
            <div className={styles.tableContainer} style={{marginTop: 25, minHeight: 0}}>
                <div className={styles.tableWrapper} style={{overflowY: "auto"}}>
                    <Table {...getTableProps()}>
                        <thead>
                        <tr style={{position: "sticky", top: 0}}>
                            <th style={{paddingLeft: 40}}>{t("poll.participantsCount", {number: data.length})}</th>
                        </tr>
                        </thead>
                        <tbody {...getTableBodyProps()}>
                        {page && page.length !== 0 ? page.map((row, index) => {
                            prepareRow(row);
                            return (
                                <tr key={index}>
                                    <td style={{paddingLeft: 40,}}>
                                        <span
                                            className={classes.row}
                                            style={{ gap: 10}}
                                        >
                                            {!!row.original.name &&
                                                <ProfileIcon size={36} initialLetter={row.original.name.toUpperCase()[0]}/>
                                            }

                                            <span style={{flex: 1, minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}>
                                                {row.original.name}
                                            </span>
                                        </span>
                                    </td>
                                </tr>
                            );
                        }) :
                            (
                                <div style={{display: "flex", flexDirection: "column", alignItems: "center", gap: 20, padding: 20}}>
                                    <NO_RESULT_FOUND/>
                                    <span>{pollType === POLL_TYPE.ATTENDANCE ? t("poll.noParticipantsAttemptedAttendance") : t("poll.noParticipantsAttemptedPoll")}</span>
                                </div>
                            )
                        }
                        </tbody>
                    </Table>
                </div>
            </div>
            <div style={{height: 10}}/>
            {page.length > 0 &&
                <NormalPagination
                    pageCount={pageCount}
                    pageIndex={pageIndex}
                    pageOptions={pageOptions}
                    canPreviousPage={canPreviousPage}
                    canNextPage={canNextPage}
                    previousPage={previousPage}
                    nextPage={nextPage}
                    gotoPage={gotoPage}
                    paddingTop="0px"
                />
            }
        </>
    );

}